
import React, { useState } from 'react';
import { Button } from "@/components/ui/button";
import { ChevronsUpDown } from "lucide-react";
import { useCustomers } from './useCustomers';
import CustomerSelectorDialog from './CustomerSelectorDialog';
import CreateCustomerDialog from './CreateCustomerDialog';
import { Customer } from './types';

export interface CustomerSelectorProps {
  onSelectCustomer: (customerId: string, customerName: string) => void;
  selectedCustomerId?: string;
  selectedCustomerName?: string;
  shopId?: string;
}

export const CustomerSelector = ({ 
  onSelectCustomer, 
  selectedCustomerId, 
  selectedCustomerName,
  shopId
}: CustomerSelectorProps) => {
  const [open, setOpen] = useState(false);
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const { customers, loading, addCustomer, refreshCustomers } = useCustomers(shopId);

  const handleCustomerCreated = (customerId: string, customerName: string) => {
    // Add the new customer to the list with required fields
    const organizationId = localStorage.getItem('currentOrganizationId') || '';
    const timestamp = new Date().toISOString();
    
    addCustomer({ 
      id: customerId, 
      name: customerName,
      organization_id: organizationId,
      created_at: timestamp
    } as Customer);
    
    // Select the new customer
    onSelectCustomer(customerId, customerName);
    
    // Close dialogs
    setCreateDialogOpen(false);
    setOpen(false);
    
    // Refresh the customers list to include the new customer
    refreshCustomers();
  };

  const handleOpenCreateDialog = () => {
    setCreateDialogOpen(true);
    setOpen(false);
  };

  console.log("CustomerSelector - open:", open, "customers:", customers.length);

  return (
    <>
      <Button 
        onClick={() => setOpen(true)}
        variant="outline"
        className="w-full justify-between border-gray-300 dark:border-gray-600 hover:bg-purple-50 dark:hover:bg-purple-900/20 focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
      >
        {selectedCustomerName || "Sélectionner un client"}
        <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
      </Button>

      <CustomerSelectorDialog 
        open={open}
        onOpenChange={setOpen}
        customers={customers}
        loading={loading}
        selectedCustomerId={selectedCustomerId}
        onSelectCustomer={onSelectCustomer}
        onCreateNew={handleOpenCreateDialog}
      />

      <CreateCustomerDialog 
        open={createDialogOpen}
        onOpenChange={setCreateDialogOpen}
        onCustomerCreated={handleCustomerCreated}
        onCancel={() => {
          setCreateDialogOpen(false);
          setOpen(true);
        }}
        preselectedShopId={shopId}
      />
    </>
  );
};

export default CustomerSelector;
